import { configureStore } from '@reduxjs/toolkit';
import customersReducer from './slices/customersSlice';
import productsReducer from './slices/productsSlice';
import ordersReducer from './slices/ordersSlice';
import recurringOrdersReducer from './slices/recurringOrdersSlice';
import creditsReducer from './slices/creditsSlice';
import seasonReducer from './slices/seasonSlice';
import inventoryReducer from './slices/inventorySlice';
import inventoryEventsReducer from './slices/inventoryEventsSlice';
import planCosechaReducer from './slices/planCosechaSlice';
import preparativosReducer from './slices/preparativosSlice';
import tarjasReducer from './slices/tarjasSlice';
import tipoCajaReducer from './slices/tipoCajaSlice';
import transportesReducer from './slices/transportesSlice';
import emailRecipientsReducer from './slices/emailRecipientsSlice';
import despachoNacionalesReducer from './slices/despachoNacionalesSlice';
import tarifasAnualesReducer from './slices/tarifasAnualesSlice';

export const store = configureStore({
  reducer: {
    customers: customersReducer,
    products: productsReducer,
    orders: ordersReducer,
    recurringOrders: recurringOrdersReducer,
    credits: creditsReducer,
    season: seasonReducer,
    inventory: inventoryReducer,
    inventoryEvents: inventoryEventsReducer,
    planCosecha: planCosechaReducer,
    preparativos: preparativosReducer,
    tarjas: tarjasReducer,
    tipoCaja: tipoCajaReducer,
    transportes: transportesReducer,
    emailRecipients: emailRecipientsReducer,
    despachoNacionales: despachoNacionalesReducer,
    tarifasAnuales: tarifasAnualesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});
